<template>
  <div class="project-editor">
    <EditorMenu></EditorMenu>
    <OpenPagesManagement></OpenPagesManagement>
    <div style="display: flex">
      <ProjectPreview key="large_editor"></ProjectPreview>
    </div>
    <v-tour
      name="editorTour"
      :steps="steps"
      :callbacks="callbacks"
      v-if="!user.editorTourCompleted"
    ></v-tour>
    <v-navigation-drawer
      v-model="siteThemeDialog"
      width="370px"
      absolute
      temporary
      hide-overlay
    >
      <v-card style="height: 100vh; overflow-y: auto">
        <v-card-title class="grey lighten-2">
          <div style="flex: 1; align-items: center">Site Theme</div>
          <v-btn
            icon
            title="Close theme editor"
            @click="siteThemeDialog = false"
          >
            <v-icon small>mdi-arrow-left</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0">
          <SiteThemeCard></SiteThemeCard>
        </v-card-text>
      </v-card>
    </v-navigation-drawer>
    <v-navigation-drawer
      v-model="showEditingBlockDrawer"
      width="370px"
      absolute
      temporary
      hide-overlay
    >
      <div style="padding-bottom: 100px">
        <Block
          :block="editingBlock"
          v-if="editingBlock"
          @close-click="showEditingBlockDrawer = false"
          :showTitle="true"
        ></Block>
      </div>
    </v-navigation-drawer>
  </div>
</template>

<script>
import axios from "axios";
import { mapState, mapActions } from "vuex";
import ProjectPreview from "../../components/project/ProjectPreview";
import Block from "../../components/project/blocks/Block";
import projectMixin from "../../components/project/project-mixin";
import EditorMenu from "../../components/project/EditorMenu";
import OpenPagesManagement from "../../components/project/OpenPagesManagement";
import SiteThemeCard from "../../components/project/SiteThemeCard";

function p(x) {
  return parseFloat(x);
}

export default {
  components: {
    ProjectPreview,
    Block,
    EditorMenu,
    OpenPagesManagement,
    SiteThemeCard,
  },
  mixins: [projectMixin],
  data() {
    return {
      siteThemeDialog: false,
      showEditingBlockDrawer: false,
      steps: [
        {
          target: "#pages-button",
          header: {
            title: "Get Started",
          },
          content: `Follow 20 seconds tutorial to see how to use Landly`,
        },
        {
          target: "#pages-button",
          header: {
            title: "Pages",
          },
          content: `See your pages here`,
        },
        {
          target: "#editor-button",
          header: {
            title: "Editor",
          },
          content: `Edit your page and blocks here`,
        },
        {
          header: {
            title: "Settings",
          },
          target: "#settings-button",
          content: "Configure project settings",
        },
        {
          header: {
            title: "Blog",
          },
          target: "#blog-button",
          content: "Write, edit, publish your blog posts",
        },
        {
          target: "#publish-button",
          content:
            "Publish your project when you want to update your live site",
        },
        {
          target: "#view-button",
          content: "Open your website in new link",
        },
        {
          target: "#view-button",
          header: {
            title: "Finish",
          },
          content: `Now you can use Landly and use blocks to create your website`,
        },
      ],
      callbacks: {
        onFinish: async () => {
          await axios.post("/Console/CompleteEditorTour", {});
          await this.getUser();
        },
        onSkip: async () => {
          await axios.post("/Console/CompleteEditorTour", {});
          await this.getUser();
        },
      },
    };
  },
  computed: {
    ...mapState(["user"]),
  },
  methods: {
    ...mapActions(["getUser"]),
    rand(arr) {
      return arr[Math.floor(Math.random() * arr.length)];
    },
    upClick(block) {
      const blocks = this.selectedPageBlocks;
      const prevBlock = blocks[block.index - 1];
      const prevPrevBlock = blocks[block.index - 2];
      let nextOrder = 0;
      if (prevPrevBlock) {
        nextOrder = (p(prevPrevBlock.order) + p(prevBlock.order)) / 2;
      } else {
        nextOrder = p(prevBlock.order) / 2;
      }
      block.order = "" + nextOrder;
      this.updateBlockOrder(block);
      this.broadcastBlockReordered();
    },
    downClick(block) {
      const blocks = this.selectedPageBlocks;
      const nextBlock = blocks[block.index + 1];
      const nextNextBlock = blocks[block.index + 2];
      let nextOrder = 0;
      if (nextNextBlock) {
        nextOrder = (p(nextNextBlock.order) + p(nextBlock.order)) / 2;
      } else {
        nextOrder = p(nextBlock.order) / 2;
      }
      block.order = "" + nextOrder;
      this.updateBlockOrder(block);
      this.broadcastBlockReordered();
    },
    editBlock(block) {
      this.SET_EDITING_BLOCK_ID(null);
      if (block == null) {
        return;
      }
      setTimeout(() => {
        this.$nextTick(() => {
          this.showEditingBlockDrawer = true;
          this.SET_EDITING_BLOCK_ID(block.id);
        });
      }, 0);
    },
    onShowSiteThemeDialog() {
      this.siteThemeDialog = true;
    },
  },
  created() {
    this.bus.$on("edit-block", this.editBlock);
    this.bus.$on("up-block", this.upClick);
    this.bus.$on("down-block", this.downClick);
    this.bus.$on("show-theme-dialog", this.onShowSiteThemeDialog);
    if (!this.user.editorTourCompleted) {
      setTimeout(() => {
        this.$tours["editorTour"].start();
      }, 2000);
    }
  },
  destroyed() {
    this.bus.$off("edit-block", this.editBlock);
    this.bus.$off("up-block", this.upClick);
    this.bus.$off("down-block", this.downClick);
    this.bus.$off("show-theme-dialog", this.onShowSiteThemeDialog);
  },
};
</script>

<style scoped>
.outline-container {
  position: fixed;
  margin-top: 72px;
  overflow-y: scroll;
  max-height: 100%;
  padding-bottom: 220px;
  border-top: 1px solid #efefef;
  width: 400px;
}
.large-editor-anim-enter-active,
.large-editor-anim-leave-active {
  transition: all 0.5s;
}
.large-editor-anim-enter,
.large-editor-anim-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>